import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateModules } from "../../actions";
import AboutUs from "@identitybuilding/idb-react-about-us";
import {
  OsnTextarea,
  Button,
  OsnInputText,
} from "@identitybuilding/idb-react-ui-elements";
import axios from "axios";
import EShop from "../E-Shop";

const AboutUsEdit = (props) => {
  const dispatch = useDispatch();

  let modules = useSelector((state) => state.AdminReducer.modules);
  let data = useSelector((state) => state.AdminReducer.data);
  let colors = useSelector((state) => state.AdminReducer.colors);

  let [eshopTitle, setEshopTitle] = useState(data.options.e_shop.title);
  let entityCopy = Object.assign({}, data);
  let modulcesCopy = [...modules];

  const handler = (action, keyword) => {
    if (action === "template") {
      entityCopy.options.e_shop.template = keyword;
      adminChange(keyword, action);
    }
    if (action === "title") {
      entityCopy.options.e_shop.title = keyword;
      adminChange(keyword, action);
    }
    if (action === "text") {
      entityCopy.options.e_shop.text = keyword;
      adminChange(keyword, action);
    }
    if (action === "theme") {
      entityCopy.options.e_shop.theme = keyword;
      adminChange(keyword, action);
    }

    modulcesCopy[props.index].module = (
      <EShop
        template={entityCopy.options.e_shop.template}
        title={entityCopy.options.e_shop.title}
        theme={entityCopy.options.e_shop.theme}
        image={entityCopy.options.e_shop.image}
      />
    );

    dispatch(updateModules(modulcesCopy));
  };

  const adminChange = (props, action) => {
    axios
      .put(
        `https://delhaize-proxy-muizen-default-rtdb.europe-west1.firebasedatabase.app/data/data/options/e_shop.json`,
        {
          [action]: props,
          ...entityCopy.options.e_shop,
        }
      )
      .then(async (resp) => {
      });
  };

  return (
    <div className="testBlock">
      <div className="testTitle">About us</div>
      <div>
        <span>Title:</span>
        <OsnInputText
          onChange={(e) => setEshopTitle(e.target.value)}
          value={eshopTitle}
          placeholder={eshopTitle}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change title"
          txtColor="white"
          type="main"
          onClick={() => handler("title", eshopTitle)}
        />
      </div>
      {/* <div>
        <span>Description:</span>
        <OsnTextarea
          onChange={(e) => setAboutUsDesciption(e.target.value)}
          value={aboutUsDesciption}
          placeholder={aboutUsDesciption}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change description"
          txtColor="white"
          type="main"
          onClick={() => handler("text", aboutUsDesciption)}
        />
      </div> */}
      {/* <div>
        <span>Template:</span>
        <ul>
          <li onClick={() => handler("template", 1)}>1</li>
          <li onClick={() => handler("template", 2)}>2</li>
          <li onClick={() => handler("template", 3)}>3</li>
          <li onClick={() => handler("template", 4)}>4</li>
        </ul>
      </div> */}
      <div>
        <span>Theme:</span>
        <ul>
          <li onClick={() => handler("theme", "dark")}>dark</li>
          <li onClick={() => handler("theme", "light")}>light</li>
        </ul>
      </div>
    </div>
  );
};
export default AboutUsEdit;
